namespace RedBullMOBILE360.CustomerCare {

    @Serenity.Decorators.registerClass('RedBullMOBILE360.CustomerCare.ManualResumeFraudCasesGrid')
    export class ManualResumeFraudCasesGrid extends Serenity.EntityGrid<ManualResumeFraudCasesRow, any> {
        protected getColumnsKey() { return ManualResumeFraudCasesColumns.columnsKey; }
        protected getDialogType() { return ManualResumeFraudCasesDialog; }
        protected getIdProperty() { return ManualResumeFraudCasesRow.idProperty; }
        protected getInsertPermission() { return ManualResumeFraudCasesRow.insertPermission; }
        protected getLocalTextPrefix() { return ManualResumeFraudCasesRow.localTextPrefix; }
        protected getService() { return ManualResumeFraudCasesService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }

        protected override getButtons(): Serenity.ToolButton[] {
            let buttons = super.getButtons();

            buttons.push({
                title: 'Import Excel',
                cssClass: 'import-button',
                onClick: () => {
                    var dialog = new ManualResumeFraudCasesExcelImportDialog();
                    dialog.element.on('dialogclose', () => {
                        if (dialog.IsDataImported)
                            this.refresh();
                    });
                    dialog.dialogOpen();
                }
            });

            buttons.push(Serenity.Extensions.ExcelExportHelper.createToolButton({
                title: 'Download Template', grid: this, service: ManualResumeFraudCasesService.baseUrl + '/DownloadTemplate', onViewSubmit: () => this.onViewSubmit()
            }));

            buttons.push(Serenity.Extensions.ExcelExportHelper.createToolButton({
                title: 'Export to Excel', grid: this, service: ManualResumeFraudCasesService.baseUrl + '/ListExcel', onViewSubmit: () => this.onViewSubmit()
            }));

            if (Q.Authorization.hasPermission(ManualResumeFraudCasesRow.updatePermission))
            buttons.push({
                title: 'Resume Fraud Cases',
                cssClass: 'apply-changes-button',
                onClick: () => {
                    Q.confirm('This will resume all staged fraud cases. Continue?', () => {
                        ManualResumeFraudCasesService.ManualResumeFraudCases({}, (response) => {
                            let messageParts = new Array<string>();
                            messageParts.push(response.Message || 'Completed');
                            if (response.FailedRecords && response.FailedRecords.length > 0) {
                                messageParts.push("<span style='color: red;'>Failed records:</span>");
                                response.FailedRecords.forEach((val) => messageParts.push(val));
                            }
                            Q.information(messageParts.join("\n"), () => { }, { htmlEncode: false });
                            this.refresh();
                        });
                    });
                }
            });

            return buttons;
        }

        protected getColumns() {
            var columns = super.getColumns();

            // Per-row delete, so a staged row that failed during resume (shown in the
            // FailedRecords list) can be removed directly without opening the dialog.
            if (Q.Authorization.hasPermission(ManualResumeFraudCasesRow.updatePermission)) {
                columns.push({
                    field: 'DeleteRow',
                    name: '',
                    width: 60,
                    sortable: false,
                    format: ctx =>
                        `<a class="delete-staged-row text-danger fw-bold" style="cursor:pointer" title="Delete this row">Delete</a>`
                });
            }

            return columns;
        }

        protected override onClick(e: JQueryEventObject, row: number, cell: number) {
            super.onClick(e, row, cell);
            if (e.isDefaultPrevented())
                return;

            if ($(e.target).closest('.delete-staged-row').length > 0) {
                e.preventDefault();
                var item = this.itemAt(row);
                if (item == null || Q.isEmptyOrNull(item.Msisdn))
                    return;

                Q.confirm(`Delete staged row for ${item.Msisdn}?`, () => {
                    ManualResumeFraudCasesService.Delete({ EntityId: item.Msisdn }, () => {
                        Q.notifySuccess("Row deleted.");
                        this.refresh();
                    });
                });
            }
        }
    }
}
